import React,{useState, useEffect} from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Pager from './Pager';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import Ajax from './Ajax';
import {Inc,Story,ResultSet} from './Inc';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MailIcon from '@material-ui/icons/Mail';
import AddIcon from '@material-ui/icons/Add';
import Loading from './Loading';
import ArchiveDetail from './ArchiveDetail';
import ArchiveDelete from './ArchiveDelete';
import './Archive.scss';

interface Props {
    uid:string,
    save(id:string):void,
    move(str:string,param?:any):void,
}

const Archive = (props:Props)=> {
    Ajax.setUid(props.uid);
    const defArchives:Story[] = [];
    const [states,setStates] = useState({
        archives: defArchives,
        isDetail: false,
        isDelete: false,
        isLoading: false,
        selected: -1,
        count: 0,
        page: 1,
        sort: "id",
        asc: false,
        per:10,
    })
    const goEdit = ()=>{
        if( states.selected!==-1 ){
            const result:ResultSet = {
                story: states.archives[states.selected],
                play: Inc.defaultPlay(),
                is_suki: false,
            }
            props.move("edit",result);
        } else {
            props.move("edit");
        }
    }
    const seeDetail = (event: React.MouseEvent<HTMLElement>)=>{
        if( !event.currentTarget.dataset.index ){
            return;
        }
        const index = parseInt(event.currentTarget.dataset.index);

        setStates({...states,"selected":index,"isDetail":true});
    }
    const seeDelete = (event: React.MouseEvent<HTMLElement>)=>{
        if( !event.currentTarget.dataset.index ){
            return;
        }
        const index = parseInt(event.currentTarget.dataset.index);
        setStates({...states,"selected":index,"isDelete":true});
    }
    const closeDetail = ()=>{
        setStates({...states,"selected":-1,"isDetail":false});
    }
    const closeDelete = ()=>{
        setStates({...states,"selected":-1,"isDelete":false});
    }
    const deleteArchive = ()=>{
        setStates({...states,"isLoading":true});
        Ajax.send("archive/delete",{id:states.archives[states.selected].id},(res:any)=>{
            if( res.ok ){
                if( states.archives.length>1 ){
                    if( states.selected>0 ){
                        setStates({...states,"isDelete":false,"isLoading":false,count:states.count-1,archives:states.archives.splice(0,states.selected).concat( states.archives.splice(states.selected) )});
                    } else {
                        setStates({...states,"isDelete":false,"isLoading":false,count:states.count-1,archives:states.archives.splice(1)});
                    }
                } else {
                    setStates({...states,"isDelete":false,"isLoading":false,count:states.count-1,archives:[]});
                }
            }
        });

    }
    const caret = (name:string,key:string)=>{
        return (
            <span onClick={changeCaret} data-id={key} className="caret">
                {name}
                {states.sort===key && states.asc &&
                    <FontAwesomeIcon icon="caret-up" style={{marginLeft:"0.5em",color:"white"}}/>
                }
                {states.sort===key && !states.asc &&
                    <FontAwesomeIcon icon="caret-down" style={{marginLeft:"0.5em",color:"white"}}/>
                }
            </span>
        )
    };
    const changeCaret = (e: React.MouseEvent<HTMLElement>)=>{
        if( e.currentTarget.dataset.id ){
            let asc = states.asc;
            if( states.sort===e.currentTarget.dataset.id ){
                asc = !asc;
            }
            setStates({...states,sort:e.currentTarget.dataset.id,asc:asc,page:1});
        }
    }
    const changePage = (newPage: number)=>{
        const el = document.getElementById("archives");
        if( el ){
            el.scrollTo(0,0);
        }
        setStates({...states,page:newPage});
    }

    const update = ()=>{
        setStates({...states,isLoading:true});
        Ajax.send("archive/list",{page:states.page,sort:states.sort,asc:states.asc,per:states.per},(res:any)=>{
            if( res.ok ){
                setStates({...states,"isLoading":false,"archives":res.archives,"count":res.count});
            }
        })
    }

    useEffect( ()=>{
        update();
    },[states.page,states.sort,states.asc])

    return (
		<div id="archives" className="root">
            <Table size="small" style={{marginTop:"1em"}}>
                <TableHead>
                    <TableRow>
                        <TableCell className="cell cell-dense nowrap" align="center">
                            {caret("新旧","id")}
                        </TableCell>
                        <TableCell className="cell nowrap">
                            {caret("タイトル","title")}
                        </TableCell>
                        <TableCell className="cell nowrap" align="right">
                            {caret("スキ","suki")}
                        </TableCell>
                        <TableCell className="cell cell-dense" align="center">
                            
                        </TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                {states.archives.map((story:Story,index:number)=>{
                    const key = "story"+index;
                    return (
                        <TableRow key={key}>
                            <TableCell className="cell cell-dense clickable" align="center" onClick={seeDetail} data-index={index}>
                                <MailIcon />
                                {!story.status &&
                                <div className="locked"><FontAwesomeIcon icon="lock"/></div>
                                }

                            </TableCell>
                            <TableCell className="cell clickable" onClick={seeDetail} data-index={index}>
                                {story.title}<br/>
                                <div>
                                    <span className="used"><FontAwesomeIcon icon="user"/> {story.used}人</span>
                                    <span className="completed"><FontAwesomeIcon icon="book-open"/> {story.completed}人</span>
                                </div>                                
                            </TableCell>
                            <TableCell className="cell cell-suki nowrap" align="right">
                                <span className="suki"><FontAwesomeIcon icon="heart"/> {story.suki}</span>
                            </TableCell>
                            <TableCell className="cell cell-dense" align="center">
                                <Tooltip title="削除する"><div className="delete" onClick={seeDelete} data-index={index}><FontAwesomeIcon icon="trash-alt"/></div></Tooltip>
                            </TableCell>
                        </TableRow>
                    )
                })}
                </TableBody>
            </Table>
            <div className="pagination">
                <Pager
                    count={states.count}
                    perPage={states.per}
                    page={states.page}
                    changePage={changePage}
                />
            </div>


            <ArchiveDetail isOpen={states.isDetail} edit={goEdit} close={closeDetail} archive={states.archives[states.selected]}/>
            <ArchiveDelete isOpen={states.isDelete} yes={deleteArchive} close={closeDelete} archive={states.archives[states.selected]}/>
            <Fab color="secondary" aria-label="add" className="btnAdd" onClick={goEdit} size="small">
                <AddIcon />
            </Fab>
            <Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default Archive;